export enum AUTH_STATUS {
  success = 'AUTH_SUCCESS',
  failure = 'AUTH_FAILURE',
}

export enum AuthQueryParams {
  success = 'success',
  error = 'error',
}

export enum OidcStatus {
  success = 'success',
  error = 'error',
}

export const oidcStorageKey = 'oidcDialog';
export const oidcStorageStatusKey = 'oidcStatus';

export enum ErrorCode {
  TOTP_REQUIRED = 'TOTP_REQUIRED',
  ACCOUNT_BLOCKED_TOO_MANY_LOGIN_ATTEMPTS = 'ACCOUNT_BLOCKED_TOO_MANY_LOGIN_ATTEMPTS',
  ACCOUNT_BLOCKED = 'ACCOUNT_BLOCKED',
  TOTP_INCORRECT = 'TOTP_INCORRECT',
  TOTP_INVALID_AUTH = 'TOTP_INVALID_AUTH',
  ATTEMPTS_LEFT = 'ATTEMPTS_LEFT',
  BAD_CREDENTIALS = 'BAD_CREDENTIALS',
  ACCOUNT_IS_AWAITING_CONFIRMATION = 'ACCOUNT_IS_AWAITING_CONFIRMATION',
  TRY_AGAIN_LATER = 'TRY_AGAIN_LATER',
}
